import { RootStore } from '../../store/types';
import { createSelector } from '@reduxjs/toolkit';

const selectVendor = (store: RootStore) => store.vendorDashboard;

const selectComments = createSelector(selectVendor, (state) => state.comments);
const selectDocuments = createSelector(selectVendor, (state) => state.documents);

const selectOrder = createSelector(selectVendor, (state) => state.order);
const selectOrders = createSelector(selectVendor, (state) => state.orders);

const selectPayoff = createSelector(selectVendor, (state) => state.payoff);
const selectPayoffs = createSelector(selectVendor, (state) => state.payoffs);

const selectTaxCertification = createSelector(selectVendor, (state) => state.taxCertification);
const selectTaxCertifications = createSelector(selectVendor, (state) => state.taxCertifications);

export const VendorSelectors = {
  selectComments,
  selectDocuments,
  selectOrder,
  selectOrders,
  selectPayoffs,
  selectPayoff,
  selectTaxCertification,
  selectTaxCertifications,
};
